import { Flex } from '@grupoboticario/flora-react';

import { Divider, Skeleton } from 'components';

import Styles from './CardCatalog.styles';

export const CardCatalogSkeleton = () => {
  return (
    <Styles.Card data-testid='skeleton-card'>
      <Styles.Grid>
        <Skeleton css={{ gridArea: 'image' }} width='$18' height='$23' />

        <Flex css={{ gridArea: 'content' }} direction='column' gap='$2'>
          <Skeleton height='$10' width='100%' />

          <Divider variant='Line' />

          <Skeleton height='$5' width='100%' />
        </Flex>

        <Flex css={{ gridArea: 'action' }} data-wrapper='buttons' direction='column' gap='$2'>
          <Skeleton height='$10' width='100%' />

          <Skeleton height='$10' width='100%' />
        </Flex>
      </Styles.Grid>
    </Styles.Card>
  );
};
